<div class="leaderboard-organisation flex flex-col gap-6 w-full min-w-0">
  @if (leadershipMembers[0]; as top) {
    <article
      class="leaderboard-organisation__featured relative overflow-hidden rounded-2xl p-6 md:p-8 flex flex-col gap-6 text-white shadow-[var(--shadow-elevated)]"
    >
      <div
        class="relative z-[1] flex w-full min-w-0 flex-col lg:flex-row lg:items-center lg:justify-between gap-6"
      >
        <div class="flex flex-col gap-4 min-w-0 flex-1 lg:pr-4">
          <span
            class="leaderboard-organisation__badge inline-flex items-center gap-2 self-start rounded-full bg-white px-3 py-1.5 text-sm font-semibold"
          >
            <img src="/icons/crown.svg" width="18" height="18" alt="" />
            #1 Top Leader
          </span>
          <div class="min-w-0">
            <h2 class="text-2xl md:text-3xl font-bold m-0 leading-tight text-white">
              {{ top.name }}
            </h2>
            <p class="mt-2 m-0 text-base text-white/85">
              {{ featuredSubtitle(top) }}
            </p>
          </div>
        </div>
        <div class="leaderboard-organisation__featured-stats w-full lg:w-auto">
          <div class="leaderboard-organisation__stat-tile">
            <span class="leaderboard-organisation__stat-label">Published</span>
            <span class="leaderboard-organisation__stat-value">
              <img src="/icons/upload-white.svg" width="22" height="22" alt="" aria-hidden="true" />
              {{ top.totalPublished ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-organisation__stat-tile">
            <span class="leaderboard-organisation__stat-label">Members</span>
            <span class="leaderboard-organisation__stat-value">
              <img src="/icons/person.svg" width="22" height="22" alt="" class="leaderboard-organisation__icon-white" aria-hidden="true" />
              {{ top.members ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-organisation__stat-tile">
            <span class="leaderboard-organisation__stat-label">Downloads</span>
            <span class="leaderboard-organisation__stat-value">
              <img src="/icons/download-white.svg" width="22" height="22" alt="" aria-hidden="true" />
              {{ top.downloads ?? 0 }}
            </span>
          </div>
        </div>
      </div>
    </article>
  }

  <ul class="flex flex-col gap-4 list-none m-0 p-0 w-full" role="list">
    @for (member of leadershipMembers.slice(1); track member.id) {
      <li
        class="leaderboard-organisation__row flex flex-col md:flex-row md:items-center gap-4 rounded-2xl border border-[var(--border-neutral)] bg-white p-4 md:p-5 shadow-[var(--shadow-card)]"
      >
        <div class="leaderboard-organisation__row-main flex items-center gap-4 min-w-0 flex-1">
          <span
            class="leaderboard-organisation__rank shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full text-base font-bold text-[var(--leaderboard-teal-dark)]"
            >{{ member.rank }}</span
          >
          <div class="min-w-0 flex flex-col gap-1">
            <h3 class="m-0 text-lg font-bold text-[var(--text-primary-on-light)]">
              {{ member.name }}
            </h3>
            <p class="m-0 text-sm text-[var(--text-muted-on-light)]">
              {{ rowSubtitle(member) }}
            </p>
          </div>
        </div>
        <div class="leaderboard-organisation__row-metrics flex flex-wrap gap-3 shrink-0 w-full md:w-auto md:justify-end">
          <div class="leaderboard-organisation__metric" data-variant="published">
            <span class="leaderboard-organisation__metric-label">Published</span>
            <span class="leaderboard-organisation__metric-value leaderboard-organisation__metric-value--published">
              <img src="/icons/upload-blue.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.totalPublished ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-organisation__metric" data-variant="members">
            <span class="leaderboard-organisation__metric-label">Members</span>
            <span class="leaderboard-organisation__metric-value leaderboard-organisation__metric-value--members">
              <img src="/icons/person.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.members ?? 0 }}
            </span>
          </div>
          <div class="leaderboard-organisation__metric" data-variant="downloads">
            <span class="leaderboard-organisation__metric-label">Downloads</span>
            <span class="leaderboard-organisation__metric-value leaderboard-organisation__metric-value--downloads">
              <img src="/icons/download-yellow.svg" width="18" height="18" alt="" aria-hidden="true" />
              {{ member.downloads ?? 0 }}
            </span>
          </div>
        </div>
      </li>
    }
  </ul>

  @if (showLoadMore) {
    <div class="flex justify-center pt-2">
      <button
        type="button"
        class="leaderboard-organisation__load-more"
        (click)="emitLoadMore()"
        [disabled]="!organisationPagination.hasNext || organisationPagination.isLoading"
      >
        @if (!organisationPagination.isLoading) {
          <span>Load more</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="shrink-0">
            <path
              d="M6 9L12 15L18 9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        } @else {
          <span>Loading…</span>
        }
      </button>
    </div>
  }
</div>
